import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent, WmsDialogBodyComponent, WmsDialogFooterComponent, WmsDialogHeaderComponent, WmsMessageComponent } from '@wms/components';
import { WMSFileUploadComponent } from '@wms/app/workspace/file-workspace/wms-file-upload/wms-file-upload.component';
import { FormsModule } from '@angular/forms';
import { get, trim } from 'lodash-es';
import { replace } from '@wms/core';

@Component({
  selector: 'wms-import-project',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    WmsMessageComponent,
    WMSFileUploadComponent
  ],
  templateUrl: './import-project.component.html',
  styleUrls: ['./import-project.component.less']
})
export class ImportProjectComponent extends BaseComponent implements OnInit {

  @Input() reImport: boolean;
  @Output() onModalClose: EventEmitter<any> = new EventEmitter<any>();
  dialogTitleRestore: string;
  message: any;
  isProjectValid: boolean = false;
  disableImportBtn: boolean;
  studioProjectId: any;
  restoreFrom: any;
  projectData: any = {};
  restore: boolean;
  processing: boolean = false;
  private project_details: any = {};
  private action: any;
  private projectType: any;
  private projectName: string = '';
  private updateProjectList: boolean;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.initImportDetails();
  }

  initImportDetails() {
    this.dialogTitleRestore = this.restore ? this.locale.LABEL_PROJECTS_RESTORE_TITLE : (this.reImport ? this.locale.LABEL_PROJECT_SRC : this.locale.LABEL_ACTIONS_IMPORT_PROJECT.replace(this.locale["LABEL_" + this.projectType]));
    if (this.projectName) {
      this.projectData.name = this.projectName + '_Copy';
    }
    this.restoreFrom = this.restore ? 'snapshot' : 'zip';
    this.project_details = this.projectService.getDetails();
    this.projectData.name = this.action === 'saveAsProjectShell' ? this.project_details.name : this.projectData.name;
    this.projectData.displayName = this.action === 'saveAsProjectShell' ? this.project_details.displayName : this.projectData.displayName;
    this.projectData.isUserDefined = false;
    this.projectData.commitMsg = '';
    this.processing = false;
  }

  setRestoreFrom(type: any) {
    // TO-DO
  }

  validateProjectName() {
    // TO-DO
  }

  initiateImport($event: any, projectImportForm: any) {
    // TO-DO
  }

  confirmImportActionCancel() {
    this.closeModal();
  }

  importProject = (formName: any) => {
    if (this.restore && this.restoreFrom !== 'zip') {
      this.updateMsg('loading', this.locale.MESSAGE_RESTORE_PROJECT);
      this.processing = true;
      // TO-DO get vcs service & reset project-id.
      return;
    }
    if (!this.projectData.zipname) {
      this.updateMsg('error', this.locale.MESSAGE_ERROR_NO_FILE_SELECTED_DESC);
      return;
    }
    if (this.reImport) {
      this.updateMsg('loading', this.locale.MESSAGE_IMPORT_PROJECT);
      this.confirmImportActionOk(formName);
      return;
    }
    if (this.isProjectValid) {
      this.updateMsg('loading', this.locale.MESSAGE_IMPORT_PROJECT);
      this.confirmImportActionOk(formName);
    }
  }

  /* Method to handle confirm ok in import dialog box */
  confirmImportActionOk(formName: any) {
    let formData,
      importConfig: any,
      packageName,
      file,
      packageDisplayName,
      projectType;
    formData = new FormData();
    file = document.forms[formName]['wmfile'].files[0];
    if (!this.reImport) {
      packageDisplayName = document.forms[formName]['packageDisplayName'].value;
      formData.append('displayName', packageDisplayName);
      formData.append('packageName', this.projectData.name);
    }
    formData.append('file', file);
    importConfig = {
      content: formData,
      action: (this.reImport ? 'reimport' : 'import')
    };
    if (this.reImport) {
      importConfig['projectId'] = (this.projectService && this.projectService.getProjectId()) || this.studioProjectId;
    }
    packageName = file && file.name;
    packageName = packageName && packageName.substr(0, packageName.lastIndexOf('.'));
    packageName = packageDisplayName || packageName;

    /* import project if it exists */
    if (packageName) {
      this.processing = true;
      (this.projectService.import(importConfig) as Promise<any>).then((project: any) => {
        this.processing = true;
        this.updateMsg('success', this.locale.MESSAGE_SUCCESS_TITLE);
        if (this.reImport && !this.updateProjectList) {
          // TO-DO cleanup stateMngrService if required.
          window.location.reload();
        } else {
          //$rootScope.importReload = true;
          //Refresh the project list after import or re-import of project
          projectType = project.projectType || project.type;
          this.closeModal();
          //Update project list only if it is in index page
          // dialogParams.updateProjectList(projectType);
        }
      }).catch((errorObj: any) => {
        this.processing = false;
        const err = get(errorObj, 'error.errors.error[0]'),
          message = replace(err.message.replaceAll('{', '${'), err.parameters) || errorObj;
        // show vcs dialog
        if (get(errorObj, err.messageKey) === 'VCS_AUTHENTICATION_FAILED') {
          this.disableImportBtn = true;
          //showUserVCSCredentialsDialog(formName, errMsg);
        } else {
          this.updateMsg('error', message);
        }
      });
    }
  }

  updateMsg(type: any, msg: any) {
    this.message = {
      type: type,
      caption: msg
    };
  }

  /*get project name & validate it*/
  getProjectName(args: any) {
    /*"files" property is not available browsers that do not support HTML5.
     * Hence fallback and use the "value" attribute.
     * However value contains the entire file path. So extract only the filename.*/
    let projectName, deleteNamePart, lastUnderScorePosition;
    if (args && args.type === 'ERROR') {
      this.isProjectValid = false;
      this.projectData.zipname = "";
      this.updateMsg('error', args.msg);
      return;
    }
    this.projectData.zipname = args.value;

    if (this.reImport) {
      this.isProjectValid = true;
    }

    if (this.projectData.zipname && !this.reImport && !this.projectData.isUserDefined) {
      projectName = this.projectData.zipname;
      projectName = projectName.substring(projectName.lastIndexOf('\\') + 1, projectName.length).replace(".zip", "");
      lastUnderScorePosition = projectName.lastIndexOf("_");
      /*if project name contains _1.0 then removing numbers and dots after last underscore .
      Ex: test_1.0 => test
          test_ab_1a.0 => test_ab_a
      */
      if (lastUnderScorePosition !== -1) {
        deleteNamePart = projectName.slice(lastUnderScorePosition + 1).replace(new RegExp("[0-9,.,(,)]", "g"), "").trim();
        projectName = projectName.slice(0, lastUnderScorePosition) + (deleteNamePart === "" ? "" : "_" + deleteNamePart);
      }
      this.projectData.name = trim(projectName);
      //$('.project-name').focus();
      this.projectData.displayName = this.projectData.name;
      this.validateProjectName();
    } else {
      this.projectData.displayName = this.projectData.name = "";
    }
  }

  closeModal() {
    this.onModalClose.emit();
  }

}
